/* This file is autogenerated, see readme.md for instructions */
import RobotSvgIcon from '@bloomreach/banana-theme/icons/robot.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RobotIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RobotSvgIcon />
    </Icon>
  );
});

RobotIcon.displayName = 'RobotIcon';

export default RobotIcon;
